import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/Caliber.css"; // Custom CSS for styling

const Caliber = () => {
  return (
    <div className="caliber-section py-5">
      <Container>
        <Row className="align-items-center">
          {/* Left Side: Career Journey Timeline */}
          <Col md={6} className="caliber-text mb-4 mb-md-0">
            <p className="caliber-subtitle">Your Career Journey with CLIF</p>

            {[
              {
                icon: "📍",
                title: "Milestone 1: Introspect",
                desc: "Tell your story in 1 minute → Get AI analysis",
              },
              {
                icon: "🚀",
                title: "Milestone 2: Assess & Learn",
                desc: "Take assessments → Discover skills → Get matched courses",
              },
              {
                icon: "🤝",
                title: "Milestone 3: Connect & Grow",
                desc: "Talk to mentors → Build resume → Apply for jobs",
              },
              {
                icon: "🎯",
                title: "Milestone 4: Achieve",
                desc: "Become job-ready → Track CLIF Score → Land your dream role",
              },
            ].map((milestone, index, array) => (
              <div key={index} className="position-relative ps-4 mb-4">
                {/* Circle */}
                <div
                  className="position-absolute top-0 start-0 rounded-circle"
                  style={{
                    width: "14px",
                    height: "14px",
                    marginTop: "7px",
                    backgroundColor: "#6600CC",
                  }}
                ></div>

                {/* Milestone Text */}
                <p className="mb-5">
                  <strong>{milestone.title}:</strong> {milestone.desc}
                </p>

                {/* Line - only if not last */}
                {index < array.length - 1 && (
                  <div
                    className="position-absolute start-0 border-start border-primary"
                    style={{ top: "20px", bottom: "-60px", marginLeft: "6px" }}
                  ></div>
                )}
              </div>
            ))}
          </Col>

          {/* Right Side: Image */}
          <Col md={6} className="p-5">
            <div className="image-placeholder text-center text-md-end">
              <img
                src="../../../images/individuals/1.jpg"
                alt="Industry Experts"
                className="img-fluid rounded"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Caliber;
